import { useEffect, useState } from 'react'
import { probe } from '@/shared'

export function useExtensionInstalled() {
  const [extensionInstalled, setExtensionInstalled] = useState(false)

  useEffect(() => {
    probe((result: any) => {
      if (result) {
        setExtensionInstalled(true)
      } else {
        setExtensionInstalled(false)
      }
    })
  }, [])

  return extensionInstalled
}
